module.exports = __webpack_public_path__ + "static/img/qq_0.5298145b.png";